import Cookies from 'js-cookie'

import { REGISTER_CHANNEL, type RegisterChannel } from '@/consts/registerChannel'

const AD_REGISTER_CHANNEL_COOKIE = 'register_channel'
const GCLID_COOKIE = 'gclid'
const REDDIT_CLICK_ID_COOKIE = 'rdt_cid'
const ATTRIBUTION_COOKIE_EXPIRY_DAYS = 30

function normalizeParam(value: string | null): string {
  return value?.trim().toLowerCase() || ''
}

function getSharedCookieOptions(): Cookies.CookieAttributes {
  const hostname = window.location.hostname
  const options: Cookies.CookieAttributes = {
    expires: ATTRIBUTION_COOKIE_EXPIRY_DAYS,
    sameSite: 'Lax',
    path: '/',
  }

  if (hostname === 'glows.ai' || hostname.endsWith('.glows.ai')) {
    options.domain = '.glows.ai'
    options.secure = true
  }

  return options
}

function setAttributionCookie(key: string, value: string): void {
  Cookies.set(key, value, getSharedCookieOptions())
}

export function isRedditAdsSource(searchParams: URLSearchParams): boolean {
  const rdtCid = searchParams.get('rdt_cid')
  const source = normalizeParam(searchParams.get('utm_source'))

  return Boolean(rdtCid) || source === 'reddit'
}

export function isKonstSource(searchParams: URLSearchParams): boolean {
  return normalizeParam(searchParams.get('utm_source')) === 'konst'
}

export function persistAdAttribution(searchParams: URLSearchParams): void {
  const gclid = searchParams.get('gclid')
  const rdtCid = searchParams.get('rdt_cid')

  // Konst is utm-only attribution; click-id based channels below take precedence.
  if (isKonstSource(searchParams)) {
    setAttributionCookie(AD_REGISTER_CHANNEL_COOKIE, String(REGISTER_CHANNEL.KONST))
  }

  if (gclid) {
    setAttributionCookie(GCLID_COOKIE, gclid)
    setAttributionCookie(AD_REGISTER_CHANNEL_COOKIE, String(REGISTER_CHANNEL.GOOGLE_ADS))
  }

  if (isRedditAdsSource(searchParams)) {
    if (rdtCid) {
      setAttributionCookie(REDDIT_CLICK_ID_COOKIE, rdtCid)
    }
    setAttributionCookie(AD_REGISTER_CHANNEL_COOKIE, String(REGISTER_CHANNEL.REDDIT_ADS))
  }
}

export function persistAdAttributionFromCurrentUrl(): void {
  persistAdAttribution(new URLSearchParams(window.location.search))
}

export function getRegisterChannelFromCookies(): RegisterChannel | undefined {
  const storedChannel = Number(Cookies.get(AD_REGISTER_CHANNEL_COOKIE))

  if (storedChannel === REGISTER_CHANNEL.GOOGLE_ADS) {
    return REGISTER_CHANNEL.GOOGLE_ADS
  }

  if (storedChannel === REGISTER_CHANNEL.REDDIT_ADS) {
    return REGISTER_CHANNEL.REDDIT_ADS
  }

  if (storedChannel === REGISTER_CHANNEL.KONST) {
    return REGISTER_CHANNEL.KONST
  }

  if (Cookies.get(GCLID_COOKIE)) {
    return REGISTER_CHANNEL.GOOGLE_ADS
  }

  if (Cookies.get(REDDIT_CLICK_ID_COOKIE)) {
    return REGISTER_CHANNEL.REDDIT_ADS
  }

  return undefined
}
